module.exports = __webpack_public_path__ + "img/zfcg_12.d4afc263.png";